/* eslint-disable no-underscore-dangle */
import React, { CSSProperties, Component } from 'react';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { clearNoteSelection } from './utils';
import { RegionType } from '../../../../slide/domain/selection/constant/region';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

interface RegionWrapperProps {
    children?: React.ReactNode;
    region: string;
    style?: CSSProperties;
}

export default class RegionWrapper extends Component<RegionWrapperProps> {
    private wrapperRef: HTMLDivElement|null;
    public componentDidMount() {
        this.useDomMouseEvent() && this.wrapperRef?.addEventListener('mousedown',  this.handleMouseDownCapture, true);
        this.wrapperRef?.addEventListener('touchstart',  this.handleMouseDownCapture, true);
    }

    public componentWillUnmount() {
        this.useDomMouseEvent() && this.wrapperRef?.removeEventListener('mousedown',  this.handleMouseDownCapture, true);
        this.wrapperRef?.removeEventListener('touchstart',  this.handleMouseDownCapture, true);
    }
    public render() {
        const events = {};
        const style = {
            width: '100%',
            height: '100%',
            ...this.props.style,
        };
        return (
            <div style={style}
                {...events}
                ref={((wrapperRef) => {
                    this.wrapperRef = wrapperRef;
                })}
            >
                {this.props.children}
            </div>
        );
    }

    private useDomMouseEvent() {
        return (!browser.isMobile || browser.isPad);
    }

    private getSelectionService() {
        return this.getAppServices().viewableServiceLayer?.selectionService;
    }

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    private handleMouseDownCapture = () => {
        const selectionService = this.getSelectionService();

        selectionService.lastMouseDownRegion = this.props.region;
        switch (this.props.region) {
            case RegionType.SLIDELIST:
                selectionService.selectedElements.clear();
                this.getAppServices().editableServiceLayer?.selectedAnims?.clear();
                clearNoteSelection();
                break;
            case RegionType.EDITOR:
                selectionService.selectedSlides.clear();
                clearNoteSelection();
                break;
            case RegionType.NOTE:
                selectionService.selectedElements.clear();
                this.getAppServices().editableServiceLayer?.selectedAnims?.clear();
                selectionService.selectedSlides.clear();
                // 清空幻灯片列表时，currentSlide不存在
                if (selectionService.currentSlide) {
                    selectionService.currentSlide.noteData.selected = true;
                }
                break;
        }
    };
}
